<template>
  <modal-provider
    name="quick-order-modal"
    :width="670"
    @before-open="beforeModalOpen"
    @before-close="beforeModalClose"
    :title="modalTitle"
  >
    <template #detached-content>
      <template v-if="isCompleteOrder && !isReserve && !isPreOrder && infoForCompletedOrder">
        <div class="success-order">
          <div class="success-order__product-name">
            {{ infoForCompletedOrder.name }}
          </div>
          <div class="success-order__divider"></div>
          <div class="success-order__product-info">
            <table class="success-order-table">
              <tr>
                <td class="success-order-table__cell">
                  {{ $t('quantity') }}
                </td>
                <td class="success-order-table__cell--value">{{ infoForCompletedOrder.itemQuantity }} шт</td>
              </tr>
              <tr v-if="!isPreOrder">
                <td class="success-order-table__cell">
                  {{ $t('sum') }}
                </td>
                <td class="success-order-table__cell--value">{{ infoForCompletedOrder.price | currencyFormatter }}</td>
              </tr>
            </table>
          </div>
        </div>
      </template>
      <template v-else-if="hasWelcomeBonus">
        <InfoMessage :title="$t('welcome_bonus_info')" type="info" />
      </template>
    </template>
    <div v-if="isCompleteOrder" class="success-order-info">
      <div class="success-order-info__img success-order-info__img--success"></div>
      <h3 class="modal__title modal__title--center success-order-info__title" :class="{'preorder__title': isPreOrder}">
        {{ successOrderTitle }}
      </h3>
      <template v-if="!isReserve">
        <h4 class="success-order-info__subtitle" :class="{'preorder__subtitle': isPreOrder}">
          {{ successOrderSubtitle }}
        </h4>
        <div class="order-number" v-if="!isPreOrder">
          <p class="order-number__text">
            {{ $t('order_number') }}
          </p>
          <p class="order-number__value">
            {{ orderNumber }}
          </p>
        </div>
        <!-- пока в предзаказе/купить в 1 клик -->
        <!-- <div v-if="notifications.length" class="delivery__info-message-wrap delivery__info-message-wrap--small">
          <InfoMessage
            v-for="(item, i) in notifications"
            :key="i"
            :title="item.title"
            :text="item.text"
            with-tooltip
            type="info"
          />
        </div> -->
        <Button class="success-order-info__button" @click.native="$modal.hide('quick-order-modal')">
          {{ $t('ok.wait') }}
        </Button>
      </template>
      <template v-else>
        <ul class="success-order-info__list">
          <li class="success-order-info__item">
            <span class="success-order-info__text">{{ $t('reserve_success_number') }}</span>
            <span class="success-order-info__text success-order-info__text--contrast">{{ orderNumber }}</span>
          </li>
          <li class="success-order-info__item">
            <span class="success-order-info__text">{{ $t('reserve_success_status') }}</span>
            <span class="success-order-info__text success-order-info__text--contrast">{{
              computedReserveStatus
            }}</span>
          </li>
          <li class="success-order-info__item">
            <span class="success-order-info__text">{{ $t('reserve_success_shop') }}</span>
            <span class="success-order-info__text success-order-info__text--contrast">{{ storeTitle }}</span>
          </li>
        </ul>
        <div v-if="notifications.length" class="delivery__info-message-wrap">
          <InfoMessage
            v-for="(item, i) in notifications"
            :key="i"
            :title="item.title"
            :text="item.text"
            with-tooltip
            type="info"
          />
        </div>
        <a :href="storeLink" target="_blank" class="success-order-info__link">{{ $t('reserve_set_road') }}</a>
        <img
          @load="triggerResize"
          v-if="staticMapLink"
          class="success-order-info__map-img"
          :src="staticMapLink"
          alt="store-map"
        />
        <a
          :href="urlLanguagePrefix + '/cabinet/order/'"
          class="success-order-info__link success-order-info__link--center"
        >
          {{ $t('reserve_to_order_history') }}
        </a>
      </template>
    </div>
    <div v-else-if="isFailedOrder" class="success-order-info">
      <div class="success-order-info__img success-order-info__img--failed"></div>
      <h3 class="modal__title modal__title--center success-order-info__title">
        {{ $t('reserve_failed_title') }}
      </h3>
      <span class="success-order-info__text success-order-info__text--contrast success-order-info__text--centered">{{
        $t('reserve_failed_text')
      }}</span>
      <button
        v-if="isReserve"
        @click="checkAvailability"
        class="success-order-info__link success-order-info__link--center"
      >
        {{ $t('reserve_failed_button') }}
      </button>
    </div>
    <div v-else-if="isAbortedOrder" class="success-order-info">
      <span v-if="!isPreOrder">{{ abortedOrderMessage }}</span>
      <template v-else>
        <div class="success-order-info__img success-order-info__img--failed"></div>
        <h3 class="modal__title modal__title--center success-order-info__title" :class="{'preorder__title': isPreOrder}">
          {{ $t('preorder_error_title') }}
        </h3>
        <template>
          <h4 class="success-order-info__subtitle" :class="{'preorder__subtitle': isPreOrder}">
            {{ $t('preorder_error_subtitle') }}
          </h4>
          <Button class="success-order-info__button" @click.native="$modal.hide('quick-order-modal')">
            {{ $t('preorder_error_btn') }}
          </Button>
        </template>
      </template>
    </div>
    <div v-else>
      <ul class="quick-order-modal__products-list">
        <template>
          <li v-for="product in products" :key="product.id" class="quick-order-modal__products-list-item">
            <cart-item
              :product="product"
              :isAllowCartManagement="orderProductsFromCart"
              @changeQuantity="changeQuantity"
              show-inner-items
            ></cart-item>
          </li>
        </template>
        <!--        <template>-->
        <!--          <ProductCard-->
        <!--            v-for="product in products"-->
        <!--            :key="product.id"-->
        <!--            :product="product"-->
        <!--            @changeQuantity="changeQuantity"-->
        <!--            is-reserve-->
        <!--            :isAllowCartManagement="orderProductsFromCart"-->
        <!--          />-->
        <!--        </template>-->
      </ul>
      <QuickOrderForm
        :isReserve="isReserve"
        :isPreOrder="isPreOrder"
        :isBuyOneClick="isBuyOneClick"
        :userData="{ name, lastName, phone }"
        :productId="productId"
        :storeId="storeId"
        :quantity="quantity"
        :status="status"
        :isFromCart="orderProductsFromCart"
        @onSubmit="submitHandler"
        @onError="errorHandler"
      />
    </div>
  </modal-provider>
</template>

<script>
import dateTimeHelpers from '@/helpers/dateTimeHelpers'
import { mapState, mapGetters, mapActions } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'
import { formattedDeliveryInfo } from '@/mixins'
// import ProductCard from '@/components/cart/ProductCard'
import InfoMessage from '@/components/helpers/InfoMessage'
import { EsputnikService, GoogleTagManagerService } from '@/services/AnalyticService'
import Button from '@/components/inputs/Button'
import CurrencyFormatter from '@/filters/CurrencyFormatter'
import QuickOrderForm from './QuickOrderForm.vue'
import CartItem from '@/components/cart/cart-item/CartItem'

const initialState = () => {
  return {
    type: null,
    isLoadingAvailability: false,
    isCompleteOrder: false,
    isFailedOrder: false,
    quantity: 1,
    maxQuantity: null,
    name: '',
    lastName: '',
    phone: null,
    orderNumber: null,
    storeId: null,
    storeLink: null,
    storeTitle: null,
    staticMapLink: null,
    status: null,
    notifications: [],
    productsData: [],
    isAbortedOrder: false,
    abortedOrderMessage: '',
    orderProductsFromCart: false
  }
}

export default {
  name: 'QuickOrderModal',
  mixins: [formattedDeliveryInfo],
  components: {
    CartItem,
    // ProductCard,
    InfoMessage,
    Button,
    QuickOrderForm
  },
  filters: {
    CurrencyFormatter
  },
  validations: {
    name: {
      required,
      minLength: minLength(2)
    },
    lastName: {
      required,
      minLength: minLength(2)
    }
  },
  data () {
    return initialState()
  },
  computed: {
    ...mapState({
      productId: state => state.productInfo.productInfo.productId,
      title: state => state.productInfo.productInfo.title,
      titleAnalytics: state => state.productInfo.productInfo.titleAnalytics,
      photos: state => state.productInfo.productInfo.photos,
      price: state => state.productInfo.productInfo.price,
      priceOld: state => state.productInfo.productInfo.oldPrice,
      code: state => state.productInfo.productInfo.code,
      productMaxAvailableQuantity: state => state.productInfo.productInfo.maxAvailableQuantity,
      pickupFromFmAvailability: state => state.productInfo.productInfo.pickupFromFmAvailability,
      isUserAuth: state => state.user.auth,
      userData: state => state.user.user_data,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      cartProducts: state => state.cart.products
    }),
    ...mapGetters(['urlLanguagePrefix', 'isManager', 'userName']),
    products () {
      if (this.orderProductsFromCart) {
        return this.cartProducts
      } else if (this.$constants.IS_PRODUCT) {
        return [{
          imageUrl: this.photos && this.photos.length ? this.photos[0].origin_photo : '',
          name: this.title,
          price: this.price,
          price_old: this.priceOld,
          currency: CurrencyFormatter('').trim(),
          itemQuantity: this.quantity,
          maxQuantity: this.isReserve || !this.pickupFromFmAvailability ? this.maxQuantity : this.productMaxAvailableQuantity,
          id: this.$store.state.productInfo.productInfo.productId,
          code: this.code
        }]
      }

      return this.productsData
    },
    hasWelcomeBonus () {
      return window.config?.hasWelcomeBonus || false
    },
    productId () {
      return this.products[0]?.id
    },
    modalTitle () {
      if (this.isCompleteOrder || this.isFailedOrder) return ''
      else if (this.isReserve) return this.$t('reserve_modal_title')
      else if (this.isAbortedOrder && this.isPreOrder) return ''
      else if (this.isPreOrder) return this.$t('product_preorder')
      else if (this.isBuyOneClick) return this.$t('quick_order')
      return ''
    },
    successOrderTitle () {
      if (this.isPreOrder) {
        return this.$t('preorder_success_title')
      }
      if (this.isReserve) {
        return this.$t('reserve_success_title')
      }
      return this.$t('thanks.your_order_completed', { name: this.userName ? `, ${this.userName.charAt(0).toUpperCase() + this.userName.slice(1)}` : '' })
    },
    successOrderSubtitle () {
      if (this.isPreOrder) {
        return this.$t('preorder_success_subtitle')
      }
      return dateTimeHelpers.isNightTime() ? this.$t('we_contact_you_soon_night') : this.$t('we_contact_you_soon')
    },
    computedReserveStatus () {
      return dateTimeHelpers.isNightTime() ? this.$t('reserve_success_status_text_night') : this.$t('reserve_success_status_text')
    },
    isReserve () {
      return this.type === 'reserve'
    },
    isPreOrder () {
      return this.type === 'pre-order'
    },
    isBuyOneClick () {
      return this.type === 'one-click'
    },
    infoForCompletedOrder () {
      if (this.products.length === 1) {
        const { price, name, itemQuantity = 1 } = this.products[0] || {}
        return {
          price: Math.round(price * itemQuantity),
          itemQuantity,
          name
        }
      }
      return false
    }
  },
  watch: {
    userData () {
      this.setUserData()
    },
    products (val) {
      if (val.length === 0) {
        this.$modal.hide('quick-order-modal')
      }
    }
  },
  methods: {
    ...mapActions(['FETCH_PRODUCT_AVAILABILITY_IN_SHOPS']),
    resetData () {
      Object.assign(this.$data, initialState())
    },
    setUserData () {
      if (!this.isManager) {
        this.phone = this.userData?.phone || ''
        this.name = this.userData?.name || ''
        this.lastName = this.userData?.['last_name'] || ''
      }
    },
    beforeModalOpen (event) {
      this.setUserData()
      this.maxQuantity = event.params?.quantity || null
      this.storeId = event.params?.storeId || null
      this.storeLink = event.params?.link || null
      this.storeTitle = event.params?.title || null
      this.staticMapLink = event.params?.staticMapLink || null
      this.status = event.params?.status || null
      this.type = event.params?.type || null
      this.productsData = event.params?.productsData || {}
      this.orderProductsFromCart = event.params?.orderProductsFromCart || false
    },
    beforeModalClose () {
      this.$v.name.$reset()
      this.$v.lastName.$reset()
      this.$store.dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', false)
      this.resetData()
    },
    changeQuantity (data) {
      this.quantity = data
    },
    submitHandler (data) {
      if (!data.success && data.message) {
        this.isAbortedOrder = true
        this.abortedOrderMessage = data.message
      } else if (!data.success) {
        this.$modal.hide('quick-order-modal')
        this.$modal.show('not-available-products', { ...data?.order['order_composition'], allProducts: [this.product] })
      }

      if (data.success) {
        this.$store.commit('UPDATE_USER_DATA', data['user_data'])
        this.isCompleteOrder = true
        this.orderNumber = data.orderNumber
        this.notifications = data.notifications
        this.sendGoogleAnalytics(data.analytics_data)

        // Отправка данных по заказу в eSputnik
        EsputnikService.sendPurchasedItemsInfo({
          products: data.analytics_data,
          orderNumber: data.orderNumber,
          tags: data.esputnikBlockId ? { 'blockId': [data.esputnikBlockId] } : null,
          isCheckout: false
        })
      }
    },
    errorHandler () {
      this.isFailedOrder = true
    },
    sendGoogleAnalytics (analyticsData) {
      const analyticOption = this.isPreOrder
        ? 'Pre-Ordered'
        : this.isBuyOneClick
          ? 'One Click Product Page'
          : this.isReserve
            ? 'One Click Product Page Reserve'
            : ''

      GoogleTagManagerService.checkoutEvent({
        analyticsData,
        actionField: { 'step': 6, 'option': analyticOption },
        params: {
          'event': 'gtm-ee-event-checkout-step-6',
          'gtm-ee-event-action': `Checkout Step 6 ${analyticOption}`
        }
      })
      GoogleTagManagerService.purchaseEvent({
        analyticsData,
        actionField: {
          'id': this.orderNumber,
          'affiliation': analyticOption,
          'revenue': analyticsData.reduce((acc, item) => acc + item.price, 0)
        },
        params: {
          'event': 'gtm-ee-event-purchase',
          'gtm-ee-event-action': `Purchase`
        }
      })
    },
    checkAvailability () {
      if (this.isLoadingAvailability) return

      if (this.productId && this.selectedUserLocation && this.selectedUserLocation.city_id) {
        this.isLoadingAvailability = true

        this.FETCH_PRODUCT_AVAILABILITY_IN_SHOPS({
          productId: this.productId,
          cityId: this.selectedUserLocation.city_id
        })
          .then(res => {
            if (res.data) {
              this.$modal.hide('quick-order-modal')
              this.$modal.show('map-modal', {
                spots: this.formatDeliverySpotsInfo(res.data.stores, 'availability'),
                mailName: 'pickup',
                title: this.$t('reserve_map_title')
              })
            }
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => (this.isLoadingAvailability = false))
      }
    },
    triggerResize () {
      window.dispatchEvent(new Event('resize'))
    }
  }
}
</script>

<style scoped lang="sass">

::v-deep
  .modal__title
    margin: 0
    +mmax($between-phone-tablet)
      font-size: 18px

    &.reserve-success__title
      padding-left: 0

  .geo-select-city
    width: 100%
    margin-bottom: 5px

  .control-box.control-box--phone
    width: 170px

.quick-order-modal__products-list
  +list-unstyled

.quick-order-modal__products-list-item
  padding: 20px 0 15px

  +mmin($tablet--hor)
    padding: 20px 0

  &:not(:first-child)
    border-top: 1px solid $nd-border-color

.control-box--phone
  margin-bottom: 20px

.success-order-info
  display: flex
  flex-direction: column
  +mmax($small)
    padding-bottom: 15px

.success-order-info__button
  align-self: center

.success-order-info__title
  font-size: 20px
  font-weight: 400
  margin-top: 20px
  padding: 0
  &.preorder__title
    font-size: 24px
    font-weight: 500
    margin-bottom: 15px

  +mmin($between-phone-tablet)
    font-size: 24px

.success-order-info__subtitle
  font-size: 14px
  color: $placeholder-color
  text-align: center
  margin: 5px 0 0
  font-weight: normal
  &.preorder__subtitle
    margin-bottom: 30px
    font-size: 16px
    line-height: 24px
    color: #333

  +mmin($between-phone-tablet)
    font-size: 16px

.success-order-info__img
  width: 76px
  height: 76px
  background-repeat: no-repeat
  background-size: contain
  margin: 0 auto

.success-order-info__img--success
  background-image: url(/img/svgo/reserve-success.svg)

.success-order-info__img--failed
  background-image: url(/img/svgo/reserve-failed.svg)

.success-order-info__list
  +list-unstyled
  margin-top: 30px

  +mmin($between-phone-tablet)
    margin-top: 40px

.success-order-info__item
  display: flex
  margin-bottom: 10px

  &:last-child
    margin-top: 20px

    +mmin($between-phone-tablet)
      margin-top: 30px

.success-order-info__text
  font-size: 14px
  font-weight: 400
  color: $placeholder-color

  &--contrast
    color: $text-color
    margin-left: 5px

  &--centered
    align-self: center
    text-align: center
    margin: 10px 0 50px

  +mmin($between-phone-tablet)
    font-size: 16px

.success-order-info__link
  color: $nd-link-color
  font-size: 14px
  border: 0
  border-bottom: 1px dashed $nd-link-color
  cursor: pointer
  display: inline-block
  max-width: max-content
  padding: 0
  background: none

  &:hover
    border-color: transparent

  &--center
    align-self: center

.success-order-info__map-img
  display: block
  width: 100%
  margin: 20px 0 30px

  +mmin($between-phone-tablet)
    margin: 30px 0 40px

.delivery__info-message-wrap
  margin: 15px 0
  &--small
    max-width: 100%
    width: 370px
    margin: 0 auto 15px auto

// .quick-order-form
//   margin: 15px 0 0

// .quick-order-form__row
//   display: flex
//   margin: 0 -5px

// .quick-order-form__col
//   width: 50%
//   padding: 2.5px 5px
//   &--full
//     width: 100%

// +mmax($small)
//   .quick-order-form__row
//     display: block
//   .quick-order-form__col
//     width: 100%
//     ::v-deep .control-box
//       min-height: unset
//   .quick-order-form__footer
//     margin-top: 40px

// .quick-order-form__footer
//   display: flex
//   align-items: center

// .agree-terms__text
//   font-size: 12px
//   line-height: 15px
//   margin-left: 30px
//   color: #909090
//   max-width: 235px
//   +mmax($small)
//   margin-left: 15px
//   .agree-terms-link
//     text-decoration: underline
//     color: #909090

.success-order
  color: $text-color
  &__divider
    height: 1px
    margin: 20px 0 10px 0
    background-color: #e7e7e7
  &__product-name
    font-size: 14px

+mmin($small)
  .success-order
    display: flex
    align-items: center
    &__product-name
      width: 50%
      font-size: 16px
    &__divider
      height: auto
      width: 1px
      align-self: stretch
      margin: 0 25px

.success-order-table
  &__cell
    color: $placeholder-color
    min-width: 110px
  &__cell--value
    white-space: nowrap
  +mmax($small)
    &__cell,&__cell--value
      font-size: 14px

.order-number
  width: 370px
  max-width: 100%
  padding: 20px 10px
  margin: 25px auto
  border: 1px dashed rgba(144, 144, 144, 0.5)
  border-radius: 3px
  display: flex
  justify-content: center
  &__text
    color: $placeholder-color
    font-size: 18px
    margin: 0
    margin-right: 15px
  &__value
    margin: 0
    color: $text-color
    font-size: 18px

+mmax($extsmall--hor)
  .order-number
    &__text, &__value
      font-size: 16px
</style>
